// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"c0e3d945","665":"bee69e19","686":"e0d60b33","710":"122deb3d"}[chunkId] + ".chunk.css";
};